import { EnumModoSelecao } from "../enums/EnumModoSelecao";
import { Selector } from "./Selector";
import { EnumTipoSelecao } from "../enums/EnumTipoSelecao";

export class SelectionTexto {
  modo: EnumModoSelecao;
  tipo: EnumTipoSelecao;
  selector: Selector;
  texto: string;

  constructor() {
    this.modo = EnumModoSelecao.Padrao;
    this.tipo = null;
  }
}
